<template>
  <base-wrapper>
    <div class="space-y-4">
      <div class="flex items-center justify-end gap-x-2">
        <office-select-search
          :shadow="false"
          v-model="filter.office"
          @change="onFilter"
        />
        <role-select-search
          :shadow="false"
          v-model="filter.role"
          @change="onFilter"
        />
        <base-input
          :shadow="false"
          placeholder="Cari No. Telp"
          type="search"
          debounce
          v-on:native-input="onFilter"
          v-model="filter.searchCellphone"
        />
        <base-input
          :shadow="false"
          placeholder="Cari Nama atau Email"
          type="search"
          debounce
          v-on:native-input="onFilter"
          v-model="filter.search"
        />
        <base-select
          :shadow="false"
          :options="[
            { key: 'null', value: null, label: 'Tipe Kantor' },
            { key: 'pusat', value: 'pusat', label: 'Pusat' },
            {
              key: 'kantor_pelayanan',
              value: 'kantor_pelayanan',
              label: 'Kantor Pelayanan',
            },
            {
              key: 'stockist_center',
              value: 'stockist_center',
              label: 'Stockist Center',
            },
            { key: 'stockist', value: 'stockist', label: 'Stockist' },
            { key: 'member', value: 'member', label: 'Mitra Usaha' },
          ]"
          v-model="filter.office_type"
          @change="onFilter"
        />
        <base-button :to="{ name: 'master.user.tambah' }"
          >Tambah User</base-button
        >
      </div>
      <datatable
        :columns="columns"
        :scroll-x="false"
        :total="users.meta.page.total"
        :perPage="users.meta.page.perPage"
        :currentPage="users.meta.page.currentPage"
        :meta="users.meta"
        cursor
        @pagechanged="onPageChanged"
      >
        <template v-slot:tbody="{ classes }">
          <tr
            v-for="user in users.data"
            :key="user.id"
            :class="[classes.tr, 'bg-white hover:bg-green-100']"
            @click="onOpenDetail(user)"
          >
            <td :class="[classes.td, 'cursor-pointer']">
              <div class="space-y-1">
                <p class="font-bold text-gray-900">
                  {{ user.attributes.name }}
                </p>
                <p class="text-xs">{{ user.attributes.email }}</p>
              </div>
            </td>
            <td :class="[classes.td, 'cursor-pointer']">
              <span v-if="!user.relationships.user.data">-</span>
              <template v-else>
                {{
                  getSingleIncludedType('user', users, user).attributes
                    .cellphone ?? '-'
                }}
              </template>
            </td>
            <td :class="[classes.td, 'cursor-pointer']">
              <span v-if="!user.relationships.user.data">-</span>
              <template v-else>
                {{
                  getSingleIncludedType('user', users, user).attributes
                    .current_role
                }}
              </template>
            </td>
            <td :class="[classes.td, 'cursor-pointer']">
              <span v-if="!user.relationships.user.data">-</span>
              <template v-else>
                <div class="flex items-center gap-x-2">
                  <span>{{
                    getSingleIncludedType(
                      'office',
                      users,
                      getSingleIncludedType('user', users, user)
                    ).attributes.code
                  }}</span>
                </div>
              </template>
            </td>
            <td :class="[classes.td, 'cursor-pointer']">
              <span v-if="!user.relationships.user.data">-</span>
              <template v-else>
                {{
                  getSingleIncludedType('user', users, user).attributes
                    .last_active | formatDate
                }}
              </template>
            </td>
            <td :class="[classes.td]">
              <router-link
                :to="{
                  name: 'master.user.edit',
                  params: {
                    id: user.attributes.user_id,
                  },
                }"
                class="underline"
                >Edit</router-link
              >
            </td>
          </tr>
        </template>
      </datatable>
    </div>

    <user-detail-modal
      :visible="detailModal.visible"
      :reload="detailModal.reload"
      :user-id="detailModal.userId"
      @close="onCloseDetail"
      @edit-password="onEditPassword"
    />
    <edit-user-password-modal
      :visible="editPasswordModal.visible"
      :user-id="editPasswordModal.userId"
      @close="onCloseEditPassword"
    />
    <success-forgot-user-password-modal
      :token="forgotPasswordModal.token"
      :phone="forgotPasswordModal.phone"
      :code="forgotPasswordModal.code"
      :name="forgotPasswordModal.name"
      :email="forgotPasswordModal.email"
      :visible="forgotPasswordModal.visible"
      @close="onCloseForgotPassword"
    />

    <loading v-if="loading" />
  </base-wrapper>
</template>

<script>
import { requestMixin } from '@/mixins/request/request';
import UserDetailModal from '@/components/user/user-detail-modal.vue';
import EditUserPasswordModal from '@/components/user/edit-user-password-modal.vue';
import OfficeSelectSearch from '@/components/office/office-select-search.vue';
import RoleSelectSearch from '@/components/role/role-select-search.vue';
import SuccessForgotUserPasswordModal from '@/components/user/success-forgot-user-password-modal.vue';

export default {
  mixins: [requestMixin],
  components: {
    UserDetailModal,
    EditUserPasswordModal,
    OfficeSelectSearch,
    RoleSelectSearch,
    SuccessForgotUserPasswordModal,
  },
  data() {
    return {
      loading: false,
      users: {
        data: [],
        meta: {
          page: {},
        },
      },
      filter: {
        search: null,
        searchCellphone: null,
        office: {
          attributes: {},
        },
        role: {
          id: null,
        },
        office_type: null,
      },
      detailModal: {
        visible: false,
        reload: true,
        userId: null,
      },
      editPasswordModal: {
        visible: false,
        userId: null,
      },
      forgotPasswordModal: {
        token: null,
        phone: null,
        code: null,
        name: null,
        email: null,
        visible: false,
      },
    };
  },
  computed: {
    columns() {
      return [
        { id: 'name', name: 'Nama' },
        { id: 'cellphone', name: 'No. Telp' },
        { id: 'role', name: 'Role' },
        { id: 'office', name: 'Office' },
        { id: 'last_login', name: 'Terakhir Login' },
        { id: 'actions', name: 'Aksi' },
      ];
    },
  },
  methods: {
    onPageChanged(page) {
      this.loadUsers({
        ...page,
      });
    },
    onFilter() {
      this.loadUsers();
    },
    onOpenDetail(user) {
      this.detailModal.userId = user.attributes.user_id;
      this.detailModal.reload = true;
      this.detailModal.visible = true;
    },
    onCloseDetail() {
      this.detailModal.visible = false;
    },
    onEditPassword(options) {
      this.detailModal.visible = false;

      if (options.link) {
        this.resetLink();
      } else {
        this.editPasswordModal.userId = this.detailModal.userId;
        this.editPasswordModal.visible = true;
      }
    },
    onCloseEditPassword() {
      this.editPasswordModal.visible = false;

      this.detailModal.reload = false;
      this.detailModal.visible = true;
    },
    onCloseForgotPassword() {
      this.forgotPasswordModal.visible = false;

      this.detailModal.reload = false;
      this.detailModal.visible = true;
    },
    async loadUsers(params) {
      this.loading = true;

      const [res, error] = await this.request('/api/v1/users', {
        params: {
          'page[limit]': 5,
          'filter[search]': this.filter.search,
          'filter[search_cellphone]': this.filter.searchCellphone,
          'filter[office_type]': this.filter.office_type,
          'filter[office_uuid]': this.filter.office.attributes
            ? this.filter.office.attributes.office_id
            : null,
          'filter[current_role_uuid]': this.filter.role.id
            ? this.filter.role.id
            : null,
          include: 'user.office',
          'fields[simple-users]': 'name,email,user_id,user',
          'fields[users]': 'current_role,office,last_active,cellphone',
          'fields[offices]': 'code,office_type',
          ...params,
        },
      });

      if (!error) {
        this.users = res;
      }

      this.loading = false;
    },
    async resetLink() {
      this.loading = true;

      const [res, error] = await this.request(
        `/api/v1/users/${this.detailModal.userId}/-actions/forgot-password`,
        {
          method: 'post',
        }
      );

      if (!error) {
        this.forgotPasswordModal.token = res.token;
        this.forgotPasswordModal.phone = res.phone;
        this.forgotPasswordModal.code = res.code;
        this.forgotPasswordModal.name = res.name;
        this.forgotPasswordModal.email = res.email;
        this.forgotPasswordModal.visible = true;
      }

      this.loading = false;
    },
  },
  created() {
    this.loadUsers();
  },
};
</script>
